export default "__VITE_ASSET__D575Gosd__"